export const SET_CAPITALIZATION_RATE = "SET_CAPITALIZATION_RATE"
